module.exports = __webpack_public_path__ + "img/googlePlay.a2c4a2b3.png";